// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"513":"e76c3daa","726":"e76c3daa","957":"db99af53"}[chunkId] + ".chunk.css";
};